export default __webpack_public_path__ + "static/patra-0995b9fccde040be2d8a3485dcabac47.png";